export enum Status {
    init = "init",
    loading = "loading",
    saved = "saved",
    error = "error"
}